export class ConnectGcpFolderRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "organizationId",
            "baseName": "organizationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "folderId",
            "baseName": "folderId",
            "type": "string",
            "format": ""
        },
        {
            "name": "managementServiceAccountId",
            "baseName": "managementServiceAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "excludeProjectPatterns",
            "baseName": "excludeProjectPatterns",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "includeLabelFilters",
            "baseName": "includeLabelFilters",
            "type": "Array<GcpLabelFilter>",
            "format": ""
        },
        {
            "name": "excludeLabelFilters",
            "baseName": "excludeLabelFilters",
            "type": "Array<GcpLabelFilter>",
            "format": ""
        },
        {
            "name": "includeTagFilters",
            "baseName": "includeTagFilters",
            "type": "Array<GcpTagFilter>",
            "format": ""
        },
        {
            "name": "excludeTagFilters",
            "baseName": "excludeTagFilters",
            "type": "Array<GcpTagFilter>",
            "format": ""
        },
        {
            "name": "regions",
            "baseName": "regions",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectGcpFolderRequest.attributeTypeMap;
    }
    constructor() {
    }
}
